import { NextPageContextEnhanced } from "../../types/page";
import {setCookie} from "utils/nookies";
import {CookiesConstants} from "utils/constants";

export function applyCountryObject(context: NextPageContextEnhanced) {
  if (context.countryCode) {
    const [countryObject] = context.essentialData
      .getCountries_ServerOnly()
      .filter((c) => c.abbreviation === context.countryCode);
    context.countryObject = countryObject || null;
    const defaultCurrency = countryObject?.currencies?.filter(currency=> currency?.id == countryObject.default_currency)?.[0]?.shorthand_en;
    setCookie(context, CookiesConstants.DEFAULT_CURRENCY, defaultCurrency);
  } else {
    context.countryObject = null;
  }
}
